import React from "react";
import { NavLink } from "react-router-dom";
import {
  RiPagesLine,
} from "react-icons/ri";
import { TbCategoryPlus } from "react-icons/tb";
import { GrProductHunt } from "react-icons/gr";
import { BiSlideshow, BiLogOut } from "react-icons/bi";
import { PiUserSwitchFill } from "react-icons/pi";
import {
  MdContentCopy,
  MdOutlineViewCarousel 
} from "react-icons/md";
import { FaVideo } from "react-icons/fa";
import { TfiWidgetized } from "react-icons/tfi";
import { IoIosContacts } from "react-icons/io";
import {FaBlog } from "react-icons/fa"
import logo from "../Images/Black-Logo.png";

const SideBar = (props) => {
  function handleLogout() {
    // sessionStorage.clear();
    localStorage.clear();
    props.setIsAuthenticated(false);
    window.location.href = "/Login";
  }
  function SwitchAccount() {
    localStorage.setItem("active_project", "gazelle");
    window.location.href = "/admin/gazelle";
  }
  return (
    <>
      <aside>
        <ul>
          <li>
            <NavLink to="/admin/rasha/">
              <img src={logo} alt="Rasha Logo" className="logo" />
            </NavLink>
          </li>
          <br />
          <li>
            <NavLink to="/admin/rasha/Pages">
              <span className="icon">
                <RiPagesLine />
              </span>
              <span> Pages</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/rasha/Products">
              <span className="icon">
                <GrProductHunt />
              </span>
              <span> Products</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/admin/rasha/Contents">
              <span className="icon">
                <MdContentCopy />
              </span>
              <span> Contents</span>
            </NavLink>
          </li>
           <li>
            <NavLink to="/admin/rasha/Blog">
              <span className="icon">
                <FaBlog />
              </span>
              <span> Blogs</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/admin/rasha/Category">
              <span className="icon">
                <TbCategoryPlus />
              </span>
              <span> Category</span>
            </NavLink>
          </li>


          <li>
            <NavLink to="/admin/rasha/ImageCarousel">
              <span className="icon">
                <MdOutlineViewCarousel  />
              </span>
              <span> ImageCarousel</span>
            </NavLink>
          </li>
              <li>
            <NavLink to="/admin/rasha/Video">
              <span className="icon">
                <FaVideo  />
              </span>
              <span> Video</span>
            </NavLink>
          </li>
  <li>
            <NavLink to="/admin/rasha/Slides">
              <span className="icon">
                <BiSlideshow />
              </span>
              <span> Slides</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/rasha/Widgets">
              <span className="icon">
                <TfiWidgetized />
              </span>
              <span> Widgets</span>
            </NavLink>
          </li>
<li>
            <NavLink to="/admin/rasha/Contact">
              <span className="icon">
                <IoIosContacts  />
              </span>
              <span> Contact Us</span>
            </NavLink>
          </li>
          <br />
          <li>
            <button onClick={SwitchAccount} className="button-switch">
              <span className="icon logoutSideBar">
                <PiUserSwitchFill />
              </span>
              <span className="switch-Span"> Switch Account</span>
            </button>
          </li>
          <li>
            <button onClick={handleLogout}>
              <span className="icon logoutSideBar">
                <BiLogOut />
              </span>
              <span className="logoutSpan"> Logout</span>
            </button>
          </li>
        </ul>
      </aside>
    </>
  );
};
export default SideBar;
